const isEmpty = require('lodash/lang/isEmpty');
const forOwn = require('lodash/object/forOwn');
const { filterPotentiallyXSS } = require('commonsUtilities/securityHelper');
//let config = require('./environmentConfig');

const services = {
    brokerGetMorningStarScreenerSecurityDetails:
        'morningstarext/{type}/security_details/{id}?originCountry={originCountry}&languageId={languageId}',
    etfsProductAnotherService: 'morningstarext/7ug1nla4nl/security/screener',
    brokerGetFundsMinAmounts: 'morningstar/funds/minimum',
    getTranslationsURL: '/config-reader/translation/{platform}/{language}',
    'global-parameters': 'cms-api/common/global-parameters',
    morningstarFundDocumentPDF:
        '/morningstar/funds/pdf/{isin}?document={documentType}&originCountry={originCountry}',
    catalogueBrokerSimpleSearch: 'wealth-catalogue/search/simple',
    catalogueBrokerSimpleSearchPublic:
        'wealth-catalogue/public/search/advanced?text={isin}&originCountry={originCountry}',
    catalogueBrokerAdvancedSearch: 'wealth-catalogue/public/search/advanced',
    allFundsLegalDocuments:
        '/fondos/allfunds/public/legaldocuments/latest/content?docType={documentType}&isin={isin}',
};

function getPublicSiteUrl() {
    return window.location.origin;
}

function getHostForEndpoint() {
    return window.okFunds && window.okFunds.baseApiUrl
        ? window.okFunds.baseApiUrl
        : 'https://api.openbank.es';
}

/**
 * Replaces the parameters in the url for its values
 *
 * @example
 * buildUrl('http://localhost/users/{id}', {id: 123}); => 'http://localhost/users/123';
 */
function buildUrl(url, params) {
    if (!params || isEmpty(params)) {
        return url;
    }

    let urlWithParams = url;

    forOwn(params, (paramValue, paramName) => {
        urlWithParams = urlWithParams.replace(`{${paramName}}`, paramValue);
    });

    return urlWithParams;
}

/**
 * It adds a trailing slash if there isn't one
 */
function normalizeHost(host) {
    if (host.substr(-1) !== '/') {
        return host + '/';
    }
    return host;
}

/**
 * It removes the slash in the front of the endpoint if there is one
 */
function normalizeEndpoint(endpoint) {
    if (endpoint.substr(0, 1) === '/') {
        return endpoint.substr(1);
    }
    return endpoint;
}

/**
 * @param {string} endpointName Name of the endpoint
 * @param {object} params Object with the data needed to create the api url
 * @example { paramName: paramValue }
 */
function getURL(endpointName, params) {
    const endpoint = services[endpointName];

    if (!endpoint || isEmpty(endpoint)) {
        throw new Error(
            `The endpoint ${endpointName} has not been found in the configuration`,
        );
    }

    const host = getHostForEndpoint(endpointName);

    const url = normalizeHost(host) + normalizeEndpoint(endpoint);

    const urlWithParams = filterPotentiallyXSS(buildUrl(url, params));

    if (
        urlWithParams.match(/{\w+}/g) &&
        urlWithParams.match(/{\w+}/g).length > 0
    ) {
        // if we still have a {} in the url, it means that some of the params hasn't
        // been sent with values. The url was not successfully created.
        // throw new EndpointNotCreated(url, params, endpoint);

        var missingParams = urlWithParams.match(/{\w+}/g).join(' ,');
        throw new Error(
            `The api url "${url}" could not be created since there are paramters missing: ${missingParams}`,
        );
    }

    return urlWithParams;
}

module.exports = {
    getURL,
    getPublicSiteUrl,
};
